import { component } from "picoapp";
import choozy from "choozy";
import { remove, add, qs, on, toggle } from "@selfaware/martha";

export default component((node, ctx) => {
  let { discountOpen, closeDiscount, discountContainer } = choozy(node);

  if (discountOpen) {
    on(discountOpen, "click", () => {        
      remove(discountContainer, "hidden");
    });

    on(closeDiscount, "click", () => {
      add(discountContainer, "hidden");
    });
  } 
});
